import type { FaireProductEntity } from "../../entity_types/product";

export const p_bqsbnl15ng: FaireProductEntity = {
  token: "p_bqsbnl15ng",
  type: "product",
  name: "Elderberry Elixir",
  brandToken: "b_6l84oay3lu",
  brandName: "Earthley Wellness",
  imageUrl:
    "https://cdn.faire.com/fastly/46f85c10d4fba1d38cffe8121aa7268a50754b0cb150bdfebeabaa9c9f49be01.jpeg",
  galleryImageUrls: [],
  priceDollars: 19.49,
  description:
    "The most potent and effective elderberry immune supplement available – our elderberry elixir is a powerful combination of elderberries and other immune-strengthening herbs. When this specialized combination works together you get the best immune boost on the market! Great for daily use, and also at first signs of cold and flu symptoms.\nSize: 4 oz.",
  tags: [],
  msrpDollars: 25.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:32.417Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
